import _ from "lodash";
import { CountryMetaData, LocalizedString } from "../api/useMusicApi";

export const ARTIST_FRONT_REACT_KEY = "front_key";
export const prepareArtistsToRequest = (countryMeta: CountryMetaData | null) => {
  return {
    ...(countryMeta?.artists ?? {}),
    main: prepareArtistToResponse(countryMeta?.artists?.main),
    featured: prepareArtistToResponse(countryMeta?.artists?.featured)
  };
};

const prepareArtistToResponse = (artists: LocalizedString[] | null | undefined) => {
  return (artists ?? []).map(a => {
    return _.omit(a, ARTIST_FRONT_REACT_KEY);
  }).map((a, index, array) => {
    if (index === 0 && a != null && array.length === 1) {
      for (const key in a) {
        if (a[key as keyof typeof a] == null || a[key as keyof typeof a] === "") {
          delete a[key as keyof typeof a];
        }
      }
    }

    return a;
  })?.filter(
    (a) => !_.isEmpty(a)
  );
};
